const ALERT_DISPLAY = async ({ commit }, message) => {
  commit('ALERT_DISPLAY', message);
};

const ALERT_HIDE = async ({ commit }) => {
  commit('ALERT_HIDE');
};

export default {
  ALERT_DISPLAY,
  ALERT_HIDE,
};
